import React from "react";
import withRouter from "../../custom/withRouter";
import { connect } from "react-redux";
import filter from "../../../assets/svg/filter.svg";
import Select from "react-select";
import axios from "axios";
import apiUrl from "../../helpers/endpointservice";
import Pagination from "react-js-pagination";
import moment from "moment";
import $ from "jquery";
import {
  paginglist,
  paginglistDefault,
  masterDataListEnum,
} from "../../custom/CommonJson";
import {
  logoutFunction,
  ToastMessageFailure,
  ToastMessageSuccess,
  Loader,
} from "../../custom/CommonFunction";
import {
  SortIcon,
  arrowleft,
  arrowright,
  FailedIcon,
  TickIcon,
  crossWhite,
  crossicon,
  UserIcon,
  Search,
  RequiredIcon,
  SaveIcon,
  EditIconRed,
  EmailIcon,
  applicationdescription,
  reseticon,
  AddMaster,
  DeleteMaster,
  LastLogin,
} from "../../custom/ImageImport";

class MasterData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
      isMobile600: false,
      isMobile380: false,
      height: window.innerHeight,
      assigngroups: [],
      applicationRoles: [],
      show: false,
      isSideView: false,
      isDelete: false,
      isDeleteFail: false,
      deleteErrorMessage: null,
      isAdd: false,
      isAddHide: false,
      isAddSuccess: false,
      isAddFailure: false,
      isEdit: false,
      isEditSuccess: false,
      isEditFailure: false,
      isView: false,
      isManage: false,
      isGroup: false,
      isRole: false,
      isManager: false,
      isImportFail: false,
      EmailError: false,
      EmailErrorEmpty: false,
      displayNameError: false,
      isLoadSpinnerTable: true,
      isFormValid: true,
      pagedefault: [],
      usersList: [],
      displayname: "",
      email: "",
      pagesize: 10,
      pagenumber: 1,
      deleteList: [],
      notifyList: [],
      managerList: [],
      managerListDefault: [],
      notifyCheckList: [],
      userId: 0,
      idnumber: 0,
      managerListAll: [],
      managerForFilter: [],
      managerForFilter1: [],
      ApplicationRole: [],
      LastLogin: "",
      addeditUser: {
        displayName: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        manager: [],
        notification_types: [],
        actionBy: "admin",
      },
      isLoaderView: false,
      roleArr: [],
      roleobj: "",
      managerList1: [],
      masters: [],
      path: "",
      masterName: "",
      masterId: 0,
      mastersList: [],
      masterDataId: 0,
      key: "",
      value: "",
      sortBy: "key",
      sortOrder: "asc",
      addeditMaster: {
        key: "",
        value: "",
        description: "",
        action_by: "admin",
      },
      keyError: false,
      valueError: false,
      dataHeading: "",
      isRoleTitle: false,
      isKeyUpdated: false,
      isValueUpdated: false,
      isClose: false,
    };
  }

  componentDidMount() {
    this.setState({
      path: window.location.pathname,
      userId: localStorage.getItem("userId"),
    });
    axios
      .get(apiUrl.GetMasters)
      .then((response) => {
        if (response?.status === 200) {
          this.setState({
            masters: response.data,
          });
          if (response.data.length > 0) {
            if (window.location.pathname == "/divisioncode") {
              let data = response.data.filter(
                (r) => r.name == "division_code"
              )[0];
              this.setState({
                masterId: data.id,
                masterName: data.value,
                pagenumber: 1,
                pagesize: 10,
                sortBy: "key",
                sortOrder: "asc",
              });
              this.getMasters(data.id, 1, 10, "key", "asc");
            }
            if (window.location.pathname == "/departmentcode") {
              let data = response.data.filter(
                (r) => r.name == "department_code"
              )[0];
              this.setState({
                masterId: data.id,
                masterName: data.value,
                pagenumber: 1,
                pagesize: 10,
                sortBy: "key",
                sortOrder: "asc",
              });
              this.getMasters(data.id, 1, 10, "key", "asc");
            }
            if (window.location.pathname == "/categorycode") {
              let data = response.data.filter(
                (r) => r.name == "category_code"
              )[0];
              this.setState({
                masterId: data.id,
                masterName: data.value,
                pagenumber: 1,
                pagesize: 10,
                sortBy: "key",
                sortOrder: "asc",
              });
              this.getMasters(data.id, 1, 10, "key", "asc");
            }
            if (window.location.pathname == "/level") {
              let data = response.data.filter((r) => r.name == "level")[0];
              this.setState({
                masterId: data.id,
                masterName: data.value,
                pagenumber: 1,
                pagesize: 10,
                sortBy: "key",
                sortOrder: "asc",
              });
              this.getMasters(data.id, 1, 10, "key", "asc");
            }
            if (window.location.pathname == "/designation") {
              let data = response.data.filter(
                (r) => r.name == "designation_name"
              )[0];
              this.setState({
                masterId: data.id,
                masterName: data.value,
                pagenumber: 1,
                pagesize: 10,
                sortBy: "key",
                sortOrder: "asc",
              });
              this.getMasters(data.id, 1, 10, "key", "asc");
            }
            if (window.location.pathname == "/mainrole") {
              let data = response.data.filter((r) => r.name == "main_role")[0];
              this.setState({
                masterId: data.id,
                masterName: data.value,
                pagenumber: 1,
                pagesize: 10,
                sortBy: "value",
                sortOrder: "asc",
                isRoleTitle: true,
              });
              this.getMasters(data.id, 1, 10, "key", "asc");
            }
            if (window.location.pathname == "/supportingrole") {
              let data = response.data.filter(
                (r) => r.name == "supporting_role"
              )[0];
              this.setState({
                masterId: data.id,
                masterName: data.value,
                pagenumber: 1,
                pagesize: 10,
                sortBy: "value",
                sortOrder: "asc",
                isRoleTitle: true,
              });
              this.getMasters(data.id, 1, 10, "key", "asc");
            }
          }
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
      });
    const intervals = setInterval(() => {
      this.resize();
    }, 10);
  }

  logoutDirect = () => {
    window.location.href = process.env.REACT_APP_LOGOUT;
  };

  componentDidUpdate() {
    if (this.state.path != window.location.pathname) {
      this.clearInputFields();
      this.setState({
        path: window.location.pathname,
        deleteList: [],
        isFormValid: true,
      });
      if (this.state.masters.length > 0) {
        if (window.location.pathname == "/divisioncode") {
          this.setState({
            masterId: 0,
            masterName: "",
            mastersList: [],
          });
          let data = this.state.masters.filter(
            (r) => r.name == "division_code"
          )[0];
          this.setState({
            masterId: data.id,
            masterName: data.value,
            isLoadSpinnerTable: true,
            pagenumber: 1,
            pagesize: 10,
            sortBy: "key",
            sortOrder: "asc",
          });
          this.getMasters(data.id, 1, 10, "key", "asc");
        }
        if (window.location.pathname == "/departmentcode") {
          this.setState({
            masterId: 0,
            masterName: "",
            mastersList: [],
          });
          let data = this.state.masters.filter(
            (r) => r.name == "department_code"
          )[0];
          this.setState({
            masterId: data.id,
            masterName: data.value,
            isLoadSpinnerTable: true,
            pagenumber: 1,
            pagesize: 10,
            sortBy: "key",
            sortOrder: "asc",
          });
          this.getMasters(data.id, 1, 10, "key", "asc");
        }
        if (window.location.pathname == "/categorycode") {
          this.setState({
            masterId: 0,
            masterName: "",
            mastersList: [],
          });
          let data = this.state.masters.filter(
            (r) => r.name == "category_code"
          )[0];
          this.setState({
            masterId: data.id,
            masterName: data.value,
            isLoadSpinnerTable: true,
            pagenumber: 1,
            pagesize: 10,
            sortBy: "key",
            sortOrder: "asc",
          });
          this.getMasters(data.id, 1, 10, "key", "asc");
        }
        if (window.location.pathname == "/level") {
          this.setState({
            masterId: 0,
            masterName: "",
            mastersList: [],
          });
          let data = this.state.masters.filter((r) => r.name == "level")[0];
          this.setState({
            masterId: data.id,
            masterName: data.value,
            isLoadSpinnerTable: true,
            pagenumber: 1,
            pagesize: 10,
            sortBy: "key",
            sortOrder: "asc",
          });
          this.getMasters(data.id, 1, 10, "key", "asc");
        }
        if (window.location.pathname == "/designation") {
          this.setState({
            masterId: 0,
            masterName: "",
            mastersList: [],
          });
          let data = this.state.masters.filter(
            (r) => r.name == "designation_name"
          )[0];
          this.setState({
            masterId: data.id,
            masterName: data.value,
            isLoadSpinnerTable: true,
            pagenumber: 1,
            pagesize: 10,
            sortBy: "key",
            sortOrder: "asc",
          });
          this.getMasters(data.id, 1, 10, "key", "asc");
        }
        if (window.location.pathname == "/mainrole") {
          let data = this.state.masters.filter((r) => r.name == "main_role")[0];
          this.setState({
            masterId: data.id,
            masterName: data.value,
            pagenumber: 1,
            pagesize: 10,
            sortBy: "value",
            sortOrder: "asc",
            isRoleTitle: true,
          });
          this.getMasters(data.id, 1, 10, "key", "asc");
        }
        if (window.location.pathname == "/supportingrole") {
          let data = this.state.masters.filter(
            (r) => r.name == "supporting_role"
          )[0];
          this.setState({
            masterId: data.id,
            masterName: data.value,
            pagenumber: 1,
            pagesize: 10,
            sortBy: "value",
            sortOrder: "asc",
            isRoleTitle: true,
          });
          this.getMasters(data.id, 1, 10, "key", "asc");
        }
      }
    }
  }

  getMasters = (id, pageNumber, pageSize, sortBy, sortOrder) => {
    axios
      .get(
        apiUrl.GetActionMasterData +
          id +
          "?key=" +
          this.state.key +
          "&value=" +
          this.state.value +
          "&sortBy=" +
          sortBy +
          "&sortOrder=" +
          sortOrder +
          "&pagesize=" +
          pageSize +
          "&pagenumber=" +
          pageNumber
      )
      .then((response) => {
        this.setState({
          mastersList: [],
        });
        if (response?.status === 200) {
          this.setState({
            mastersList: response.data,
            isLoadSpinnerTable: false,
          });
        } else {
          this.setState({
            isLoadSpinnerTable: false,
          });
        }
      })
      .catch((error) => {
        this.setState({
          isLoadSpinnerTable: false,
        });
        logoutFunction(error?.response?.status);
      });
  };

  resize = () => {
    if (window.innerWidth < 850) {
      this.state.isMobile = true;
    } else {
      this.state.isMobile = false;
    }

    if (window.innerWidth < 600) {
      this.state.isMobile600 = true;
    } else {
      this.state.isMobile600 = false;
    }

    if (window.innerWidth < 380) {
      this.state.isMobile380 = true;
    } else {
      this.state.isMobile380 = false;
    }
    this.state.height = window.innerHeight;
    this.setState({});
  };

  showSearchScreen = () => {
    this.clearData();
    this.setState({
      isAddHide: false,
      keyError: false,
      valueError: false,
      isAdd: true,
      isEdit: false,
      isView: false,
      keyAlreadyExists: false,
      valueAlreadyExists: false,
      isClose: false,
    });
    this.props.dispatch({ type: "EDIT_CANCEL", data: false });

    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("sideScreen")
    );
    myOffcanvas.show();
  };

  manageLicense = () => {
    this.setState({ isManage: true });
  };

  handleViewData = (id) => {
    this.state.idnumber = id;
    this.setState({});
  };

  handlePageChange = (pageNumber) => {
    this.state.pagenumber = pageNumber;
    this.state.deleteList = [];
    this.state.isLoadSpinnerTable = true;
    this.setState({});
    this.getMasters(
      this.state.masterId,
      this.state.pagenumber,
      this.state.pagesize,
      this.state.sortBy,
      this.state.sortOrder
    );
  };

  handleAddApplication = () => {
    this.clearData();
    this.setState({
      isView: false,
      isEdit: false,
      isAdd: true,
    });
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("sideScreen")
    );
    myOffcanvas.show();
    this.props.dispatch({ type: "EDIT_CANCEL", data: false });
  };

  previousPage = () => {
    this.state.pagenumber = this.state.pagenumber - 1;
    this.state.isLoadSpinnerTable = true;
    this.setState({});
    this.getMasters(
      this.state.masterId,
      this.state.pagenumber,
      this.state.pagesize,
      this.state.sortBy,
      this.state.sortOrder
    );
  };

  nextPage = () => {
    this.state.pagenumber = this.state.pagenumber + 1;
    this.state.isLoadSpinnerTable = true;
    this.setState({});
    this.getMasters(
      this.state.masterId,
      this.state.pagenumber,
      this.state.pagesize,
      this.state.sortBy,
      this.state.sortOrder
    );
  };

  sorting = (sortby) => {
    if (sortby == this.state.sortBy) {
      this.state.sortBy = sortby;
      if (this.state.sortOrder == "asc") {
        this.state.sortOrder = "desc";
      } else {
        this.state.sortOrder = "asc";
      }
    } else {
      this.state.sortBy = sortby;
      this.state.sortOrder = "asc";
    }
    this.state.pagenumber = 1;
    this.state.isLoadSpinnerTable = true;
    this.setState({}, () => {
      this.getMasters(
        this.state.masterId,
        this.state.pagenumber,
        this.state.pagesize,
        this.state.sortBy,
        this.state.sortOrder
      );
    });
  };

  pageSize = (e) => {
    this.state.pagesize = e.value;
    this.state.pagenumber = 1;
    this.state.isLoadSpinnerTable = true;
    this.setState({});
    this.getMasters(
      this.state.masterId,
      this.state.pagenumber,
      this.state.pagesize,
      this.state.sortBy,
      this.state.sortOrder
    );
  };

  handleInputSearch = (e, val) => {
    this.state[val] = e.target.value;
    this.setState({});
  };

  showFilterSearch = () => {
    this.setState({ isFormValid: true });
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("searchScreen")
    );
    myOffcanvas.show();
  };

  handleFilterSearch = () => {
    const isInputValid =
      (this.state.isRoleTitle == false &&
        (this.state.key != "" || this.state.value != "")) ||
      (this.state.isRoleTitle == true && this.state.value != "");
    if (isInputValid) {
      this.setState({
        isFormValid: true,
        isLoadSpinnerTable: true,
        pagenumber: 1,
      });
      this.getMasters(
        this.state.masterId,
        1,
        this.state.pagesize,
        this.state.sortBy,
        this.state.sortOrder
      );

      document.getElementById("closeSearch").click();
    } else {
      this.setState({ isFormValid: false });
    }
  };

  clearInputFields = () => {
    this.state.key = "";
    this.state.value = "";
    this.state.pagenumber = 1;
    this.getMasters(
      this.state.masterId,
      1,
      this.state.pagesize,
      this.state.sortBy,
      this.state.sortOrder
    );
  };

  handleFilterClear = (str) => {
    this.state[str] = "";
    this.setState({ isAddHide: false });
    this.getMasters(
      this.state.masterId,
      this.state.pagenumber,
      this.state.pagesize,
      this.state.sortBy,
      this.state.sortOrder
    );
  };

  handleCheckbox = (id) => {
    const { deleteList } = this.state;
    if (deleteList.length == 0) {
      deleteList.push(id);
    } else {
      if (deleteList && deleteList.filter((i) => i == id).length == 1) {
        deleteList.map((i, ind) => (i == id ? deleteList.splice(ind, 1) : ""));
      } else {
        deleteList.push(id);
      }
    }
    this.setState({});
  };

  handleCheckboxTop = () => {
    let data = [];

    if (
      this.state.deleteList?.length !=
        this.state.mastersList?.masterData?.length &&
      this.state.deleteList?.length > 0 &&
      this.state.mastersList?.masterData?.length > 0
    ) {
      this.state.mastersList?.masterData?.map((r) => data.push(r.id));
    }

    if (
      this.state.deleteList?.length == 0 &&
      this.state.mastersList?.masterData?.length > 0
    ) {
      this.state.mastersList?.masterData?.map((r) => data.push(r.id));
    }

    if (
      this.state.deleteList?.length ==
        this.state.mastersList?.masterData?.length &&
      this.state.mastersList?.masterData?.length > 0
    ) {
      data = [];
    }

    this.state.deleteList = data;
    this.setState({});
  };

  handleCheckboxNotify = (id) => {
    const { notification_types } = this.state.addeditUser;
    if (notification_types?.length == 0) {
      notification_types?.push(id);
    } else {
      if (
        notification_types &&
        notification_types?.filter((i) => i == id).length == 1
      ) {
        notification_types?.map((i, ind) =>
          i == id ? notification_types?.splice(ind, 1) : ""
        );
      } else {
        notification_types?.push(id);
      }
    }
    this.setState({});
  };

  handleEditButton = () => {
    this.setState({ isLoaderView: true });

    $("#sideScreen").attr("data-bs-backdrop", "static");

    this.setState({
      isEdit: true,
      isView: false,
      isAdd: false,
      keyAlreadyExists: false,
      valueAlreadyExists: false,
      isClose: false,
      OldKey: this.state.addeditMaster.key,
      OldValue: this.state.addeditMaster.value,
    });

    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("sideScreen")
    );
    myOffcanvas.show();
    this.props.dispatch({ type: "EDIT_CANCEL", data: true });
    setTimeout(() => {
      this.setState({ isLoaderView: false });
    }, 500);
  };

  DeleteYes = () => {
    this.setState({ isLoadSpinnerTable: true });
    let deleteData = "";
    let val = "";

    this.state.deleteList?.map(
      (r, idx) => (
        (val = "," + r), idx == 0 ? (deleteData += r) : (deleteData += val)
      )
    );

    axios
      .delete(
        apiUrl.GetActionMasterData +
          this.state.masterId +
          "/" +
          deleteData +
          "/" +
          this.state.userId
      )
      .then((response) => {
        if (response?.status === 200) {
          this.setState({ pagenumber: 1 });
          this.getMasters(
            this.state.masterId,
            1,
            this.state.pagesize,
            this.state.sortBy,
            this.state.sortOrder
          );
          this.state.deleteList = [];
          this.setState({});
          this.setState({
            isDelete: true,
            isAddSuccess: false,
            isEditSuccess: false,
          });
          setTimeout(() => {
            this.setState({ isDelete: false });
          }, 4000);
        } else {
          this.setState({
            isDeleteFail: true,
          });
          setTimeout(() => {
            this.setState({ isDeleteFail: false });
          }, 4000);
        }
        this.setState({ isLoadSpinnerTable: false });
      })
      .catch((error) => {
        let errMsg = null;
        if (
          (this.state.masterName == masterDataListEnum.MAINROLE ||
            this.state.masterName == masterDataListEnum.SUPPORTINGROLE) &&
          error?.response?.data?.code === 409
        ) {
          errMsg = error?.response?.data?.message;
        }
        this.setState({
          isDeleteFail: true,
          deleteErrorMessage: errMsg,
        });
        setTimeout(() => {
          this.setState({ isDeleteFail: false });
        }, 4000);
        logoutFunction(error?.response?.status);
        this.setState({ isLoadSpinnerTable: false });
      });
  };

  handleInputAddEdit = (e, str) => {
    const { isEdit } = this.state;
    this.state.addeditMaster[str] = e.target.value;
    if (str === "key") {
      this.state.isKeyUpdated = true;
    } else if (str === "value") {
      this.state.isValueUpdated = true;
    }
    this.setState({});
    if (
      this.state.addeditMaster?.key.trim() != "" &&
      this.state.addeditMaster?.value.trim() != ""
    ) {
      //this.setState({ isAddHide: true });
    } else {
      //this.setState({ isAddHide: false });
    }
  };

  handleEditPage = (id) => {
    this.state.masterDataId = id;
    this.setState({
      isLoaderView: true,
    });
    this.clearData();
    this.setState({
      isView: true,
      isAdd: false,
      isEdit: false,
      masterDataId: id,
      keyError: false,
      valueError: false,
    });
    this.getviewData(id);
    this.props.dispatch({ type: "EDIT_CANCEL", data: false });
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("sideScreen")
    );
    myOffcanvas.show();
  };

  getviewData = (id) => {
    axios
      .get(apiUrl.GetActionMasterData + this.state.masterId + "/" + id)
      .then((response) => {
        if (response?.status === 200) {
          this.setState({
            addeditMaster: {
              key: response.data?.key,
              value: response.data?.value,
              description: response.data?.description
                ? response.data?.description
                : "",
              historyLog: response?.data?.historyLog || [],
            },
            dataHeading:
              this.state.isRoleTitle == true
                ? response.data?.value
                : response.data?.key,
          });
          if (response.data.key != "" || response.data.value != "") {
            //this.setState({ isAddHide: true });
          } else {
            // this.setState({ isAddHide: false });
          }
          this.setState({
            isLoaderView: false,
          });
        } else {
          this.setState({
            isLoaderView: false,
          });
        }
      })
      .catch((error) => {
        this.setState({
          isLoaderView: false,
        });
        logoutFunction(error?.response?.status);
      });
  };

  handleAddEdit = () => {
    const { isEdit, isKeyUpdated, isValueUpdated, isAdd } = this.state;
    this.state.keyAlreadyExists = false;
    this.state.valueAlreadyExists = false;
    if (this.state.addeditMaster.key?.trim() === "") {
      this.state.keyError = true;
    }
    if (this.state.addeditMaster.key?.trim() != "") {
      this.state.keyError = false;
    }
    if (this.state.addeditMaster.value?.trim() === "") {
      this.state.valueError = true;
    }
    if (this.state.addeditMaster.value?.trim() != "") {
      this.state.valueError = false;
    }

    this.setState({});

    if (this.state.keyError == true) {
      document.getElementById("keyId")?.focus();
    } else if (this.state.valueError == true) {
      document.getElementById("valueId")?.focus();
    }
    let key = [],
      value = [],
      isValid = false;
    this.state.mastersList?.masterData?.map((item) => {
      key.push(item.key.toLowerCase());
      value.push(item.value.toLowerCase());
    });

    if (this.state.isRoleTitle == false) {
      if (
        this.state.addeditMaster.key?.trim() != "" &&
        this.state.addeditMaster.value?.trim() != ""
      ) {
        if (
          !key.includes(this.state.addeditMaster.key?.trim().toLowerCase()) &&
          !value.includes(this.state.addeditMaster.value?.trim().toLowerCase())
        ) {
          isValid = true;
        }

        // this.setState({
        //   isAddHide: false,
        // });
        if (isValid) {
          // this.setState({
          //   isAddHide: false,
          // });

          let data = {
            key: this.state.addeditMaster.key,
            value: this.state.addeditMaster.value,
            description: this.state.addeditMaster.description,
            action_by: this.state.userId,
          };
          if (this.state.isAdd == true) {
            this.postdata(data);
          }

          this.setState({
            isAdd: false,
            isEdit: false,
            isView: false,
            isClose: true,
          });
        } else {
          if (
            key.includes(this.state.addeditMaster.key?.trim().toLowerCase())
          ) {
            this.setState({ keyAlreadyExists: true, isClose: false });
          } else {
            this.setState({ keyAlreadyExists: false, isClose: true });
          }
          if (
            value.includes(this.state.addeditMaster.value?.trim().toLowerCase())
          ) {
            this.setState({ valueAlreadyExists: true, isClose: false });
          } else {
            this.setState({ valueAlreadyExists: false, isClose: true });
          }
        }
      }
    }
    if (this.state.isRoleTitle == true) {
      if (this.state.addeditMaster.value?.trim() != "") {
        if (
          !value.includes(this.state.addeditMaster.value?.trim().toLowerCase())
        ) {
          // this.setState({
          //   isAddHide: false,
          // });
          let data = {
            key: this.state.addeditMaster.value,
            value: this.state.addeditMaster.value,
            description: this.state.addeditMaster.description,
            action_by: this.state.userId,
          };
          if (this.state.isAdd == true) {
            this.postdata(data);
          }

          this.setState({
            isAdd: false,
            isEdit: false,
            isView: false,
            isClose: true,
          });
        } else {
          this.setState({ valueAlreadyExists: true, isClose: false });
        }
      }
    }
    this.props.dispatch({ type: "EDIT_CANCEL", data: false });
  };

  handleEdit = () => {
    const { isEdit, isKeyUpdated, isValueUpdated, isAdd } = this.state;
    this.state.keyAlreadyExists = false;
    this.state.valueAlreadyExists = false;
    if (this.state.addeditMaster.key?.trim() === "") {
      this.state.keyError = true;
    }
    if (this.state.addeditMaster.key?.trim() != "") {
      this.state.keyError = false;
    }
    if (this.state.addeditMaster.value?.trim() === "") {
      this.state.valueError = true;
    }
    if (this.state.addeditMaster.value?.trim() != "") {
      this.state.valueError = false;
    }

    this.setState({});

    if (this.state.keyError == true) {
      document.getElementById("keyId")?.focus();
    } else if (this.state.valueError == true) {
      document.getElementById("valueId")?.focus();
    }
    let key = [],
      value = [],
      isKeyValid = false,
      isValueValid = false;

    this.state.mastersList?.masterData?.map((item) => {
      key.push(item.key.toLowerCase());
      value.push(item.value.toLowerCase());
    });
    let KeyEdit = key?.filter((r) => r !== this.state.OldKey.toLowerCase());
    let ValueEdit = value?.filter(
      (r) => r !== this.state.OldValue.toLowerCase()
    );
    if (this.state.isRoleTitle == false) {
      if (
        this.state.addeditMaster.key?.trim() != "" &&
        this.state.addeditMaster.value?.trim() != ""
      ) {
        if (this.state.isEdit) {
          if (
            !KeyEdit.includes(
              this.state.addeditMaster.key?.trim().toLowerCase()
            )
          ) {
            isKeyValid = true;
          } else {
            isKeyValid = false;
          }
          if (
            !ValueEdit.includes(
              this.state.addeditMaster.value?.trim().toLowerCase()
            )
          ) {
            isValueValid = true;
          } else {
            isValueValid = false;
          }
        }
        // this.setState({
        //   isAddHide: false,
        // });
        if (isKeyValid && isValueValid) {
          // this.setState({
          //   isAddHide: false,
          // });

          let data = {
            key: this.state.addeditMaster.key,
            value: this.state.addeditMaster.value,
            description: this.state.addeditMaster.description,
            action_by: this.state.userId,
          };

          if (this.state.isAdd == false) {
            this.putdata(data, this.state.masterDataId);
          }
          this.setState({
            isAdd: false,
            isEdit: false,
            isView: false,
            isClose: true,
          });
        } else {
          if (
            //isKeyUpdated &&
            KeyEdit.includes(this.state.addeditMaster.key?.trim().toLowerCase())
          ) {
            this.setState({ keyAlreadyExists: true, isClose: false });
          }
          if (
            //isValueUpdated &&
            ValueEdit.includes(
              this.state.addeditMaster.value?.trim().toLowerCase()
            )
          ) {
            this.setState({ valueAlreadyExists: true, isClose: false });
          }
        }
      }
    }
    if (this.state.isRoleTitle == true) {
      if (this.state.addeditMaster.value?.trim() != "") {
        if (
          !ValueEdit.includes(
            this.state.addeditMaster.value?.trim().toLowerCase()
          )
        ) {
          // this.setState({
          //   isAddHide: false,
          // });
          let data = {
            key: this.state.addeditMaster.value,
            value: this.state.addeditMaster.value,
            description: this.state.addeditMaster.description,
            action_by: this.state.userId,
          };

          if (this.state.isAdd == false) {
            this.putdata(data, this.state.masterDataId);
          }
          this.setState({
            isAdd: false,
            isEdit: false,
            isView: false,
            isClose: true,
          });
        } else {
          this.setState({ valueAlreadyExists: true, isClose: false });
        }
      }
    }
    this.props.dispatch({ type: "EDIT_CANCEL", data: false });
  };
  postdata = (data) => {
    this.setState({ isLoadSpinnerTable: true });
    axios
      .put(apiUrl.GetActionMasterData + this.state.masterId, data)
      .then((response) => {
        if (response?.status === 200) {
          this.setState({
            isAddSuccess: true,
            isEditSuccess: false,
            isDelete: false,
          });
          setTimeout(() => {
            document.getElementById("closeModal")?.click();
          }, 100);
          setTimeout(() => {
            this.setState({ isAddSuccess: false });
          }, 4000);
          this.getMasters(
            this.state.masterId,
            this.state.pagenumber,
            this.state.pagesize,
            this.state.sortBy,
            this.state.sortOrder
          );
          this.setState({
            addeditMaster: {
              key: "",
              value: "",
              description: "",
              action_by: "admin",
            },
            isAddHide: true,
          });
        } else {
          this.setState({ isAddFailure: true });
          setTimeout(() => {
            this.setState({ isAddFailure: false });
          }, 4000);
        }
        this.setState({ isLoadSpinnerTable: false });
      })
      .catch((error) => {
        this.setState({ isAddFailure: true });
        setTimeout(() => {
          this.setState({ isAddFailure: false });
        }, 4000);
        logoutFunction(error?.response?.status);
        this.setState({ isLoadSpinnerTable: false });
      });
  };

  putdata = (data, id) => {
    this.setState({ isLoadSpinnerTable: true });
    axios
      .put(apiUrl.GetActionMasterData + this.state.masterId + "/" + id, data)
      .then((response) => {
        if (response?.status === 200) {
          this.getMasters(
            this.state.masterId,
            this.state.pagenumber,
            this.state.pagesize,
            this.state.sortBy,
            this.state.sortOrder
          );
          this.setState({
            addeditMaster: {
              key: "",
              value: "",
              description: "",
              action_by: "admin",
            },
            isAddHide: true,
          });
          this.setState({
            isEditSuccess: true,
            isAddSuccess: false,
            isDelete: false,
          });
          setTimeout(() => {
            document.getElementById("closeModal")?.click();
          }, 100);
          setTimeout(() => {
            this.setState({ isEditSuccess: false });
          }, 4000);
        } else {
          this.setState({ isEditFailure: true });
          setTimeout(() => {
            this.setState({ isEditFailure: false });
          }, 4000);
        }
        this.setState({ isLoadSpinnerTable: false });
      })
      .catch((error) => {
        this.setState({ isEditFailure: true });
        setTimeout(() => {
          this.setState({ isEditFailure: false });
        }, 4000);
        logoutFunction(error?.response?.status);
        this.setState({ isLoadSpinnerTable: false });
      });
  };

  validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  handleManagerAction = (e) => {
    this.state.addeditUser.manager = e;
    this.setState({});
  };

  cancelToastMessage = () => {
    this.setState({
      isDelete: false,
      isAddSuccess: false,
      isAddFailure: false,
      isEditFailure: false,
      isEditSuccess: false,
      isAddHide: false,
    });
  };

  clearData = () => {
    this.setState({
      addeditMaster: {
        key: "",
        value: "",
        description: "",
        actionBy: "admin",
      },
    });
  };

  CancelYes = () => {
    this.setState({ isEdit: false });
    this.props.dispatch({ type: "EDIT_CANCEL", data: false });
    this.clearData();
    document.getElementById("clearEditYes").click();
    $("#sideScreen").attr("data-bs-backdrop", "true");
  };

  render() {
    const {
      isMobile,
      isMobile600,
      isMobile380,
      isLoadSpinnerTable,
      sortBy,
      sortOrder,
      usersList,
      pagenumber,
      isAdd,
      isEdit,
      isImportFail,
      isView,
      height,
      deleteList,
      isDelete,
      notifyList,
      addeditUser,
      isAddFailure,
      isAddSuccess,
      isEditFailure,
      isEditSuccess,
      isDeleteFail,
      isRoleTitle,
    } = this.state;
    let { classes } = this.props;
    return (
      <>
        <Loader loader={this.state.isLoaderView || isLoadSpinnerTable} />
        <div
          className={isMobile ? "" : this.props.sideMenu ? "ml-50" : "ml-250"}
        >
          {isMobile == true ? (
            <div className="row mobile-head w-100 border-bottom margin-left-14px">
              <div className="col-12">
                <label className="text-14-bold">{this.state.masterName}</label>
              </div>
            </div>
          ) : (
            <>
              <div className="sub-modules w-100">
                <table width="100%" className="border-bottom">
                  <tbody>
                    <tr>
                      <td>
                        <label className="module-head pl-20 pt-4 pb-4 pr-3">
                          {this.state.masterName}
                        </label>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </>
          )}
          <div
            className={isMobile ? "action-table1" : "action-table"}
            style={{
              width: isMobile
                ? "100%"
                : this.props.sideMenu
                ? "calc(100% - 50px)"
                : "calc(100% - 250px)",
            }}
          >
            <table width="100%">
              <tbody>
                <tr>
                  <td width="90%" className="d-flex align-middle">
                    <div
                      className="d-flex cursor-pointer back-hover pl-10"
                      onClick={this.showSearchScreen}
                    >
                      <img
                        src={AddMaster}
                        className={`${
                          isMobile380
                            ? "px-1 img-height-45"
                            : "px-2 img-height-45 mt-3px"
                        } py-3`}
                      />
                      <label
                        className={`${
                          isMobile380
                            ? "pt-13 text-12-normal"
                            : "pt-15 text-14-normal"
                        } cursor-pointer pr-10`}
                      >
                        {isMobile600
                          ? "Add"
                          : "Add " + this.state.masterName?.toLowerCase()}
                      </label>
                    </div>
                    <div
                      className={`${
                        deleteList?.length > 0 ? `` : `pointer-none`
                      } d-flex cursor-pointer back-hover`}
                      data-bs-toggle="modal"
                      data-bs-target="#deleteModal"
                    >
                      <img
                        src={DeleteMaster}
                        className={`${
                          isMobile380
                            ? "px-1 img-height-45"
                            : "px-2 img-height-45 mt-3px"
                        } ${deleteList?.length > 0 ? `` : `opacity02`} py-3`}
                      />
                      <label
                        className={`${
                          isMobile380
                            ? "pt-13 text-12-normal"
                            : "pt-15 text-14-normal "
                        } ${
                          deleteList?.length > 0 ? `` : `color-img`
                        } cursor-pointer pr-10`}
                      >
                        {isMobile600
                          ? "Delete"
                          : "Delete " + this.state.masterName?.toLowerCase()}
                      </label>
                    </div>
                  </td>
                  <td width="10%" className="text-end">
                    <img
                      src={filter}
                      className={`${
                        isMobile380 ? "img-height-45 p-3" : "p-3"
                      } cursor-pointer`}
                      onClick={this.showFilterSearch}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            className={isMobile ? "sub-modules1-table" : "sub-modules-table"}
            style={{
              height: isMobile ? height - 200 : height - 255,
              width: isMobile
                ? "100%"
                : this.props.sideMenu
                ? "calc(100% - 50px)"
                : "calc(100% - 250px)",
            }}
          >
            <div className="table-responsive common-table-bottom">
              <table width="100%" id="usersTable" className="pb-2">
                <thead className="border-bottom">
                  <tr>
                    <th className="p-3 border-bottom border-top" width="3%">
                      <div
                        className="form-group-check"
                        onClick={() => this.handleCheckboxTop()}
                      >
                        <input
                          type="checkbox"
                          checked={
                            deleteList?.length > 0 &&
                            deleteList?.length ==
                              this.state.mastersList?.masterData?.length
                              ? true
                              : false
                          }
                        />
                        <label htmlFor="checkbox"></label>
                      </div>
                    </th>
                    <th
                      className="p-3 border-bottom border-top display-width"
                      width={isRoleTitle == true ? "79%" : "29%"}
                      onClick={() =>
                        this.sorting(isRoleTitle == false ? "key" : "value")
                      }
                    >
                      <label className="text-12-bold cursor-pointer pr-10">
                        {isRoleTitle == false ? "Key" : "Role title"}
                      </label>
                      {(isRoleTitle == false && sortBy == "key") ||
                      (isRoleTitle == true &&
                        sortBy == "value" &&
                        sortOrder) ? (
                        <img
                          src={SortIcon}
                          className={
                            sortOrder == "asc"
                              ? "cursor-pointer"
                              : "cursor-pointer rotate-180"
                          }
                        />
                      ) : (
                        ""
                      )}
                    </th>
                    {isRoleTitle == false && (
                      <th
                        className="p-3 border-top border-bottom"
                        width="50%"
                        onClick={() => this.sorting("value")}
                      >
                        <label className="text-12-bold cursor-pointer pr-10">
                          Value
                        </label>
                        {sortBy == "value" ? (
                          <img
                            src={SortIcon}
                            className={
                              sortOrder == "asc"
                                ? "cursor-pointer "
                                : "cursor-pointer rotate-180"
                            }
                          />
                        ) : (
                          ""
                        )}
                      </th>
                    )}
                  </tr>
                </thead>
                {isLoadSpinnerTable == false && (
                  <>
                    <tbody>
                      {this.state.mastersList?.masterData?.length > 0 ? (
                        this.state.mastersList?.masterData?.map((i, idx) => (
                          <>
                            <tr
                              key={idx}
                              className={
                                deleteList?.filter((r) => r == i.id)?.length > 0
                                  ? "required-backcolor"
                                  : ""
                              }
                            >
                              <td className="align-middle border-bottom p-3 text-center">
                                <div
                                  className="form-group-check"
                                  onClick={() => this.handleCheckbox(i.id)}
                                >
                                  <input
                                    type="checkbox"
                                    checked={
                                      deleteList?.filter((r) => r == i.id)
                                        ?.length > 0
                                        ? true
                                        : false
                                    }
                                  />
                                  <label htmlFor="checkbox"></label>
                                </div>
                              </td>
                              <td className="border-bottom p-3">
                                <label
                                  className="text-12-bold cursor-pointer text-decoration"
                                  onClick={() => this.handleEditPage(i.id)}
                                >
                                  {isRoleTitle == true ? i.value : i.key}
                                </label>
                              </td>
                              {isRoleTitle == false && (
                                <td className="border-bottom p-3">
                                  <label className="text-12-normal">
                                    {i.value}
                                  </label>
                                </td>
                              )}
                            </tr>
                          </>
                        ))
                      ) : (
                        <tr>
                          <td className="border-bottom"></td>
                          <td
                            className={`py-2 no-content-message no-wrap border-bottom`}
                            colSpan={3}
                          >
                            No data found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </>
                )}
              </table>
            </div>
          </div>
          <div
            className={`${
              isMobile
                ? "common-mobilesubmenu mobile-pagination"
                : this.props.sideMenu
                ? "common-submenu sidemenu-pagination"
                : "common-submenu web-pagination"
            } pb-2 pt-2`}
          >
            <table width="100%">
              <tbody>
                <tr>
                  <td width="8%" className="p-3">
                    <div className="select-width">
                      {this.state.mastersList?.pagination?.totalcount ? (
                        <Select
                          options={paginglist}
                          defaultValue={paginglistDefault}
                          value={[
                            {
                              label: this.state.pagesize?.toString(),
                              value: this.state.pagesize,
                            },
                          ]}
                          classNamePrefix="paging"
                          isSearchable={false}
                          menuPlacement={"top"}
                          menuPosition={"fixed"}
                          onChange={(e) => this.pageSize(e)}
                          styles={{
                            control: (base, state) => ({
                              ...base,
                              boxShadow: "none", // no box-shadow
                            }),
                          }}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </td>

                  <td width="92%" className="text-end p-3">
                    {isMobile ? (
                      this.state.mastersList?.pagination?.totalcount ? (
                        <Pagination
                          prevPageText={
                            <>
                              <img src={arrowleft} />
                            </>
                          }
                          nextPageText={
                            <>
                              <img src={arrowright} />
                            </>
                          }
                          linkClassNext="nextArrow"
                          linkClassPrev="prevArrow"
                          itemClass={`page-item`}
                          linkClass="page-link"
                          pageRangeDisplayed={1}
                          onChange={(e) => this.handlePageChange(e)}
                          activePage={this.state.pagenumber}
                          totalItemsCount={
                            this.state.mastersList?.pagination?.totalcount
                          }
                          itemsCountPerPage={
                            this.state.mastersList?.pagination?.pageSize
                          }
                        />
                      ) : (
                        ""
                      )
                    ) : this.state.mastersList?.pagination?.totalcount ? (
                      <Pagination
                        prevPageText={
                          <>
                            <img src={arrowleft} />
                          </>
                        }
                        nextPageText={
                          <>
                            <img src={arrowright} />
                          </>
                        }
                        linkClassNext="nextArrow"
                        linkClassPrev="prevArrow"
                        itemClass={`page-item`}
                        linkClass="page-link"
                        pageRangeDisplayed={4}
                        onChange={(e) => this.handlePageChange(e)}
                        activePage={this.state.pagenumber}
                        totalItemsCount={
                          this.state.mastersList?.pagination?.totalcount
                        }
                        itemsCountPerPage={
                          this.state.mastersList?.pagination?.pageSize
                        }
                      />
                    ) : (
                      ""
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <ToastMessageFailure
            messageShow={isEditFailure || isAddFailure || isDeleteFail}
            isMobile={isMobile}
            messageText={
              (isAddFailure && this.state.masterName + " failed to save") ||
              (isEditFailure && this.state.masterName + " failed to update") ||
              (isDeleteFail &&
                (this.state.deleteErrorMessage ||
                  this.state.masterName + " failed to delete"))
            }
            handleClose={() => this.cancelToastMessage()}
          />

          <ToastMessageSuccess
            messageShow={isEditSuccess || isAddSuccess || isDelete}
            isMobile={isMobile}
            //messageText="Supporting role saved successfully"
            messageText={
              (isEditSuccess &&
                this.state.masterName + " updated successfully") ||
              (isAddSuccess && this.state.masterName + " saved successfully") ||
              (isDelete && this.state.masterName + " deleted successfully")
            }
            handleClose={() => this.cancelToastMessage()}
          />

          <div
            className="offcanvas offcanvas-end offcanvasStyle"
            tabIndex={-1}
            data-bs-scroll="false"
            data-bs-backdrop="true"
            id="searchScreen"
            aria-labelledby="offcanvasScrollingLabel"
          >
            <div className="offcanvas-header px-4 pt-4 pb-2 m-1"> {/* offcanvas-header pb-3 */}
              <h6 id="offcanvasRightLabel" className="modal-title text-20-bold">
                Search
              </h6>
              <img
                src={crossicon}
                className={`cursor-pointer text-reset offcavasclose ${
                  isMobile ? "pr-0" : ""
                }`}
                data-bs-dismiss="offcanvas"
              ></img>
            </div>
            <div className="offcanvas-body px-4 pt-2 pb-4 m-1 scroll-css"> {/* offcanvas-body pl-4 pr-5 scroll-css */}
              <div className="row">
                <>
                  {isRoleTitle == false && (
                    <div
                      className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2`}
                    >
                      <label
                        className={
                          isMobile
                            ? "d-flex pt-2 m-0"
                            : "d-flex m-0 text-left float-start"
                        }
                      >
                        <img src={UserIcon} className="contact-icon" />{" "}
                        <span className="pl-10 text-12-bold">Key</span>
                        &nbsp;
                      </label>
                      {isMobile && (
                        <div className={`col-12 mt-2 `}>
                          <div>
                            <input
                              className="input-text input-clear text-12-normal w-100"
                              type="text"
                              maxLength={255}
                              autoComplete="off"
                              value={this.state.key}
                              onChange={(e) => this.handleInputSearch(e, "key")}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                  <div
                    className={
                      isRoleTitle
                        ? `col-12`
                        : `col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 `
                    }
                  >
                    <label
                      className={
                        isMobile
                          ? "d-flex pt-2 m-0"
                          : "d-flex m-0 text-left float-start"
                      }
                    >
                      <img src={EmailIcon} />{" "}
                      <span className="pl-10 text-12-bold">
                        {isRoleTitle == true ? "Role title" : "Value"}
                      </span>
                      &nbsp;
                    </label>
                    {isMobile && (
                      <div>
                        <input
                          className="input-text text-12-normal w-100"
                          type="text"
                          maxLength={255}
                          autoComplete="off"
                          value={this.state.value}
                          onChange={(e) => this.handleInputSearch(e, "value")}
                        />
                      </div>
                    )}
                  </div>
                  {!isMobile && (
                    <>
                      {isRoleTitle == false && (
                        <div
                          className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 `}
                        >
                          <div>
                            <input
                              className="input-text input-clear text-12-normal w-100"
                              type="text"
                              maxLength={255}
                              autoComplete="off"
                              value={this.state.key}
                              onChange={(e) => this.handleInputSearch(e, "key")}
                            />
                          </div>
                        </div>
                      )}
                      <div
                        className={
                          isRoleTitle
                            ? `col-12`
                            : `col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 `
                        }
                      >
                        <div>
                          <input
                            className="input-text text-12-normal w-100"
                            type="text"
                            maxLength={255}
                            autoComplete="off"
                            value={this.state.value}
                            onChange={(e) => this.handleInputSearch(e, "value")}
                          />
                        </div>
                      </div>
                    </>
                  )}
                  <button
                    id="closeSearch"
                    className="offcavasclose d-none"
                    data-bs-dismiss="offcanvas"
                  ></button>
                  {!this.state.isFormValid && (
                    <p className="pt-3 message-search required-color">
                      At least one field is mandatory
                    </p>
                  )}
                  <div
                    className={`${
                      this.state.isFormValid ? "mt-3" : ""
                    } col-12 d-flex`}
                  >
                    <div>
                      <button
                        className="action-button px-3 py-2"
                        onClick={this.handleFilterSearch}
                      >
                        <img src={Search} className="img-top" /> Search
                      </button>
                    </div>
                    <div className="mx-3">
                      <button
                        className="reset-button  px-3"
                        onClick={() => this.clearInputFields()}
                      >
                        <img src={reseticon} className="img-top reset-image" />{" "}
                        Reset
                      </button>
                    </div>
                  </div>
                </>
              </div>
            </div>
          </div>
          <div
            className="offcanvas offcanvas-end offcanvasStyle audit-offcanvas"
            tabIndex={-1}
            data-bs-scroll="false"
            data-bs-backdrop="true"
            id="sideScreen"
            aria-labelledby="offcanvasScrollingLabel"
          >
            {!this.state.isLoaderView && (
              <div className="offcanvas-header px-4 pt-4 pb-2 m-1">
                <h6
                  id="offcanvasRightLabel"
                  className="modal-title text-20-bold"
                >
                  {isAdd && "Add " + this.state.masterName}
                  {!isAdd && this.state.dataHeading}
                </h6>
                {isEdit ? (
                  <img
                    src={crossicon}
                    data-bs-toggle="modal"
                    data-bs-target="#cancelModal"
                    className={`cursor-pointer text-reset offcavasclose ${
                      isMobile ? "pr-0" : ""
                    }`}
                  ></img>
                ) : (
                  <img
                    src={crossicon}
                    className={`cursor-pointer text-reset offcavasclose ${
                      isMobile ? "pr-0" : ""
                    }`}
                    data-bs-dismiss="offcanvas"
                    onClick={() => this.clearData()}
                  ></img>
                )}
                <button
                  className="offcavasclose d-none"
                  data-bs-dismiss="offcanvas"
                  id="clearEditYes"
                ></button>
              </div>
            )}
            <div className="offcanvas-body px-4 pt-2 pb-4 m-1 scroll-css">
              {!this.state.isLoaderView && (
                <div className="row">
                  <>
                    {isView && (
                      <div
                        className={`col-12 mb-2`}
                        data-bs-dismiss="offcanvas"
                      >
                        <label
                          className={
                            isMobile
                              ? "d-flex pt-2 m-0 cursor-pointer"
                              : "d-flex m-0 text-left float-start cursor-pointer"
                          }
                          onClick={() => this.handleEditButton()}
                        >
                          <img src={EditIconRed} />{" "}
                          <span className="pl-10 text-12-bold text-decoration">
                            Edit
                          </span>
                          &nbsp;
                        </label>
                      </div>
                    )}
                    {isRoleTitle == false && (
                      <div className={isMobile ? "col-12" : "col-6 mt-4"}>
                        <label
                          className={
                            isMobile
                              ? "d-flex pt-2 m-0"
                              : "d-flex m-0 text-left float-start"
                          }
                        >
                          <img src={UserIcon} className="contact-icon" />{" "}
                          <span className="pl-10 text-12-bold">
                            Key&nbsp;
                            {!isView && (
                              <span className="required-color">*</span>
                            )}
                          </span>
                          &nbsp;
                        </label>
                        {isMobile && (
                          <div className={isView ? `col-12` : `col-12 pt-1`}>
                            {isEdit || isAdd ? (
                              <>
                                <input
                                  type="text"
                                  maxLength={255}
                                  autoComplete="off"
                                  className={`${
                                    this.state.keyError ||
                                    this.state.keyAlreadyExists
                                      ? `border-input`
                                      : ``
                                  } ${`input-text text-12-normal w-100`}`}
                                  value={
                                    this.state.addeditMaster.key &&
                                    this.state.addeditMaster.key
                                  }
                                  id="keyId"
                                  onChange={(e) =>
                                    this.handleInputAddEdit(e, "key")
                                  }
                                />
                                {this.state.keyAlreadyExists && (
                                  <>
                                    {/* <img src={RequiredIcon} />
                                    &nbsp; */}
                                    <label className="required">
                                      Key is already exists
                                    </label>
                                  </>
                                )}
                                {this.state.keyError && (
                                  <>
                                    <img src={RequiredIcon} />
                                    &nbsp;
                                    <label className="required">Required</label>
                                  </>
                                )}
                              </>
                            ) : (
                              <span className="view-text">
                                {this.state.addeditMaster.key &&
                                  this.state.addeditMaster.key}
                              </span>
                            )}
                          </div>
                        )}
                      </div>
                    )}

                    <div
                      className={
                        isMobile || isRoleTitle ? "col-12" : "col-6 mt-4"
                      }
                    >
                      <label
                        className={
                          isMobile
                            ? "d-flex pt-2 m-0"
                            : "d-flex m-0 text-left float-start"
                        }
                      >
                        <img src={EmailIcon} />{" "}
                        <span className="pl-10 text-12-bold">
                          {isRoleTitle ? "Role title" : "Value"}&nbsp;
                          {!isView && <span className="required-color">*</span>}
                        </span>
                        &nbsp;
                      </label>
                      {isMobile && (
                        <div className={isView ? `col-12` : `col-12 pt-1`}>
                          {isEdit || isAdd ? (
                            <>
                              <input
                                type="text"
                                maxLength={255}
                                autoComplete="off"
                                className={`${
                                  this.state.valueError ||
                                  this.state.valueAlreadyExists
                                    ? `border-input`
                                    : ``
                                } ${`input-text text-12-normal w-100`}`}
                                value={
                                  this.state.addeditMaster.value &&
                                  this.state.addeditMaster.value
                                }
                                onChange={(e) =>
                                  this.handleInputAddEdit(e, "value")
                                }
                                id="valueId"
                              />
                              {this.state.valueAlreadyExists && (
                                <>
                                  {/* <img src={RequiredIcon} />
                                  &nbsp; */}
                                  <label className="required">
                                    Value is already exists
                                  </label>
                                </>
                              )}
                              {this.state.valueError && (
                                <>
                                  <img src={RequiredIcon} />
                                  &nbsp;
                                  <label className="required">
                                    {"Required"}
                                  </label>
                                </>
                              )}
                            </>
                          ) : (
                            <span className="view-text">
                              {this.state.addeditMaster.value &&
                                this.state.addeditMaster.value}
                            </span>
                          )}
                        </div>
                      )}
                    </div>

                    {!isMobile && (
                      <>
                        {isRoleTitle == false && (
                          <div
                            className={
                              isView
                                ? `col-6`
                                : `col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 pt-1`
                            }
                          >
                            {isEdit || isAdd ? (
                              <>
                                <input
                                  type="text"
                                  maxLength={255}
                                  autoComplete="off"
                                  className={`${
                                    this.state.keyError ||
                                    this.state.keyAlreadyExists
                                      ? `border-input`
                                      : ``
                                  } ${`input-text text-12-normal w-100`}`}
                                  value={
                                    this.state.addeditMaster.key &&
                                    this.state.addeditMaster.key
                                  }
                                  onChange={(e) =>
                                    this.handleInputAddEdit(e, "key")
                                  }
                                  id="keyId"
                                />
                                {this.state.keyAlreadyExists && (
                                  <>
                                    {/* <img src={RequiredIcon} />
                                    &nbsp; */}
                                    <label className="required">
                                      Key is already exists
                                    </label>
                                  </>
                                )}
                                {this.state.keyError && (
                                  <>
                                    <img src={RequiredIcon} />
                                    &nbsp;
                                    <label className="required">Required</label>
                                  </>
                                )}
                              </>
                            ) : (
                              <span className="view-text">
                                {this.state.addeditMaster.key &&
                                  this.state.addeditMaster.key}
                              </span>
                            )}
                          </div>
                        )}
                        <div
                          className={
                            isView
                              ? `col-6`
                              : `col-12 col-sm-12 col-lg-${
                                  this.state.isRoleTitle ? "12" : "6"
                                } col-xl-${
                                  this.state.isRoleTitle ? "12" : "6"
                                } col-md-${
                                  this.state.isRoleTitle ? "12" : "6"
                                } pt-1`
                          }
                        >
                          {isEdit || isAdd ? (
                            <>
                              <input
                                type="text"
                                maxLength={255}
                                autoComplete="off"
                                className={`${
                                  this.state.valueError ||
                                  this.state.valueAlreadyExists
                                    ? `border-input`
                                    : ``
                                } ${`input-text text-12-normal w-100`}`}
                                value={
                                  this.state.addeditMaster.value &&
                                  this.state.addeditMaster.value
                                }
                                onChange={(e) =>
                                  this.handleInputAddEdit(e, "value")
                                }
                                id="valueId"
                              />
                              {this.state.valueAlreadyExists && (
                                <>
                                  {/* <img src={RequiredIcon} />
                                    &nbsp; */}
                                  <label className="required">
                                    {this.state.isRoleTitle
                                      ? "Role title is already exists"
                                      : "Value is already exists"}
                                  </label>
                                </>
                              )}
                              {this.state.valueError && (
                                <>
                                  <img src={RequiredIcon} />
                                  &nbsp;
                                  <label className="required">Required</label>
                                </>
                              )}
                            </>
                          ) : (
                            <span className="view-text">
                              {this.state.addeditMaster.value &&
                                this.state.addeditMaster.value}
                            </span>
                          )}
                        </div>
                      </>
                    )}
                    <div className={isMobile ? "col-12" : "col-12 mt-4"}>
                      <label
                        className={
                          isMobile
                            ? "d-flex pt-2 m-0"
                            : "d-flex m-0 text-left float-start"
                        }
                      >
                        <img className="mt-1" src={applicationdescription} />{" "}
                        <span className="pl-10 text-12-bold">
                          Description&nbsp;
                        </span>
                        &nbsp;
                      </label>
                    </div>
                    {isMobile && (
                      <div className={isView ? `col-12` : `col-12 pt-1`}>
                        {isEdit || isAdd ? (
                          <>
                            <textarea
                              rows="3"
                              className="pad-para text-12-normal input-textarea w-100"
                              value={this.state.addeditMaster.description}
                              onChange={(e) =>
                                this.handleInputAddEdit(e, "description")
                              }
                            ></textarea>
                          </>
                        ) : (
                          <span className="view-text">
                            {this.state.addeditMaster.description &&
                              this.state.addeditMaster.description}
                          </span>
                        )}
                      </div>
                    )}
                    {!isMobile && (
                      <div className={isView ? `col-12 pt-1` : `col-12 pt-1`}>
                        {isEdit || isAdd ? (
                          <>
                            <textarea
                              rows="3"
                              className="pad-para text-12-normal input-textarea w-100"
                              value={this.state.addeditMaster.description}
                              onChange={(e) =>
                                this.handleInputAddEdit(e, "description")
                              }
                            ></textarea>
                          </>
                        ) : (
                          <span className="view-text">
                            {this.state.addeditMaster.description &&
                              this.state.addeditMaster.description}
                          </span>
                        )}
                      </div>
                    )}
                    {isView &&
                      this.state.addeditMaster?.historyLog?.length > 0 && (
                        <div>
                          <div className="pt-4">
                            <h6 className="text-20-bold">Audit log</h6>
                          </div>
                          <div className="audit-table-wrapper audit-scroll-css table-fixed-header">
                            <table className="px-3 audit-table">
                              <thead>
                                <tr className="border-bottom">
                                  <th className="p-rem">Action</th>
                                  <th className="p-rem w-23">Action By</th>
                                  <th className="p-rem wid-45">Description</th>
                                  <th className="p-rem">Date</th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.addeditMaster?.historyLog.map(
                                  (x) => (
                                    <tr className="border-bottom">
                                      <td className="p-rem align-top">
                                        {x.action}
                                      </td>
                                      <td className="p-rem align-top">
                                        {x.actionBy}
                                      </td>
                                      <td className="p-rem">{x.description}</td>
                                      <td className="p-rem align-top">
                                        {moment
                                          .utc(x.createdTime)
                                          .local()
                                          .format("DD-MMM-YYYY hh:mm A")}
                                        {/* {moment(x.createdTime).format("DD-MMM-YYYY, h:mm A")} */}
                                      </td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      )}
                    <div className="col-12 mt-2">
                      <button
                        className="d-none"
                        data-bs-dismiss={this.state.isClose && "offcanvas"}
                        id="closeModal"
                      >
                        {" "}
                        Save
                      </button>
                      {isAdd && (
                        <button
                          className="action-button px-3 py-2"
                          //data-bs-dismiss={this.state.isAddHide && "offcanvas"}
                          onClick={this.handleAddEdit}
                        >
                          <img className="img-top" src={SaveIcon} /> &nbsp; Save
                        </button>
                      )}
                      {isEdit && (
                        <button
                          className="action-button px-3 py-2"
                          //data-bs-dismiss={this.state.isAddHide && "offcanvas"}
                          onClick={this.handleEdit}
                        >
                          <img className="img-top" src={SaveIcon} /> &nbsp; Save
                          changes
                        </button>
                      )}
                    </div>
                  </>
                </div>
              )}
            </div>
          </div>
          <div
            id="largeModal"
            className="modal fade modal-top"
            tabIndex="-1"
            role="dialog"
          >
            <div className="modal-dialog modal-all">
              <div className="modal-content px-4">
                <div className="row">
                  <div className="col-8">
                    <div className="px-1 py-3 align-middle border-bottom-modal">
                      {isImportFail && (
                        <>
                          <img src={FailedIcon} className="top-margin" />
                          <label className="modal-title text-20-bold pl-10">
                            Failed to Upload
                          </label>
                        </>
                      )}
                    </div>
                  </div>
                  <div className="col-4 d-flex justify-content-end align-middle border-bottom-modal px-1 py-3">
                    <img
                      src={crossicon}
                      data-bs-dismiss="modal"
                      className={`cursor-pointer img-width ${
                        isMobile ? "pr-0" : ""
                      }`}
                    ></img>
                  </div>
                </div>
                <div className="">
                  {isImportFail && (
                    <>
                      <label className="text-14-normal fw-bold py-3">
                        Users failed to import
                      </label>
                      <div className="px-3">
                        <table width="100%" className="px-3">
                          <thead>
                            <tr className="border-bottom">
                              <th className="py-2" width="15%">
                                S.No
                              </th>
                              <th className="py-2" width="25%">
                                Cell name
                              </th>
                              <th className="py-2" width="60%">
                                Description
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr className="border-bottom">
                              <td className="py-2">1</td>
                              <td className="py-2">A</td>
                              <td className="py-2">
                                User Already exists in a current group
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </>
                  )}
                </div>
                <div className="py-3 text-center"></div>
              </div>
            </div>
          </div>

          <div
            id="deleteModal"
            className="modal fade modal-top"
            tabIndex="-1"
            role="dialog"
          >
            <div className="modal-dialog modal-all">
              <div className="modal-content px-4">
                <div className="row">
                  <div className="col-12">
                    <div className="px-1 py-3 align-middle border-bottom-modal">
                      <img src={FailedIcon} className="top-margin" />
                      <label className="modal-title text-20-bold pl-10">
                        Warning
                      </label>
                    </div>
                  </div>
                </div>
                <div className="">
                  <div>
                    <label className="text-16-bold pt-3">
                      {"Are you sure want to remove the " +
                        this.state.masterName +
                        "?"}
                    </label>
                  </div>
                  <div>
                    <label className="text-12-normal py-3">
                      {"All the information about the " +
                        this.state.masterName +
                        " will be lost."}
                    </label>
                  </div>
                </div>
                <div className="py-3 text-center">
                  <button
                    className="cancel-button text-12-bold px-4 py-2"
                    data-bs-dismiss="modal"
                  >
                    No
                  </button>
                  <button
                    className="success-button text-12-bold px-4 py-2 ml-10"
                    data-bs-dismiss="modal"
                    onClick={this.DeleteYes}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div
            id="cancelModal"
            className="modal fade modal-top"
            tabIndex="-1"
            role="dialog"
          >
            <div className="modal-dialog modal-all">
              <div className="modal-content px-4">
                <div className="row">
                  <div className="col-12">
                    <div className="px-1 py-3 align-middle border-bottom-modal">
                      <img src={FailedIcon} className="top-margin" />
                      <label className="modal-title text-20-bold pl-10">
                        Warning
                      </label>
                    </div>
                  </div>
                </div>
                <div className="">
                  <div>
                    <label className="text-16-bold pt-3">
                      Are you sure you want to close?
                    </label>
                  </div>
                  <div>
                    <label className="text-12-normal py-3">
                      {"All the information you've entered for your " +
                        this.state.masterName +
                        " will be lost."}
                    </label>
                  </div>
                </div>
                <div className="py-3 text-center">
                  <button
                    className="cancel-button text-12-bold px-4 py-2"
                    data-bs-dismiss="modal"
                  >
                    No
                  </button>
                  <button
                    className="success-button text-12-bold px-4 py-2 ml-10"
                    data-bs-dismiss="modal"
                    onClick={this.CancelYes}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

function mapStateToProps(state) {
  return {
    sideMenu: state.commonReducer.sideMenu,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MasterData)
);
